


export function validVideo() {
    return (['mp4', 'avi', 'mkv', 'mov', 'wmv', 'ogg']);
}

export function validImages() {
    return (['png','jpg','jpeg']);
}

export default validImages();